import React from 'react';
import { Skeleton } from '@mui/material';

export const ProductDetailRightSkeleton = () => {
  const loadingArray = [1, 2, 3, 4];

  return (
    <div className="product_detail_right_section">
      <Skeleton variant="text" width="75%" height={40} animation="wave" sx={{ mb: 2 }} />
      {/* Mode toggle row */}
      <div className="flex items-center gap-3 mb-3">
        <Skeleton variant="text" width={110} height={22} animation="wave" />
        <Skeleton variant="rectangular" width={48} height={24} animation="wave" sx={{ borderRadius: 12 }} />
        <Skeleton variant="text" width={90} height={22} animation="wave" />
      </div>

      {/* Price section (two large prices with captions) */}
      <div className="mb-3">
        <div className="flex items-start gap-12">
          <div className="flex flex-col items-start">
            <Skeleton variant="text" width={120} height={36} animation="wave" sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width={70} height={14} animation="wave" />
          </div>
          <div className="flex flex-col items-start">
            <Skeleton variant="text" width={120} height={36} animation="wave" sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width={100} height={14} animation="wave" />
          </div>
        </div>
      </div>

      <Skeleton variant="text" width="25%" height={25} animation="wave" sx={{ mb: 2 }} />
      <div className="flex gap-2 mb-4">
        {loadingArray.map(i => (
          <Skeleton key={i} variant="rectangular" width={80} height={90} animation="wave" sx={{ borderRadius: 1 }} />
        ))}
      </div>

      <Skeleton variant="text" width="30%" height={25} animation="wave" sx={{ mb: 1 }} />
      <div className="border border-gray-200 rounded-md mb-4">
        {loadingArray.map(i => (
          <div key={i} className="flex items-center justify-between p-3 border-b last:border-b-0">
            <div className="flex items-center gap-3 flex-1">
              <Skeleton variant="rectangular" width={40} height={40} animation="wave" sx={{ borderRadius: 1 }} />
              <div className="flex-1">
                <Skeleton variant="text" width="75%" animation="wave" />
                <Skeleton variant="text" width="50%" animation="wave" />
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Skeleton variant="text" width={60} animation="wave" />
              <Skeleton variant="rectangular" width={120} height={28} animation="wave" sx={{ borderRadius: 1 }} />
            </div>
          </div>
        ))}
      </div>

      <Skeleton variant="text" width="35%" height={25} animation="wave" sx={{ mb: 1 }} />
      <Skeleton variant="rectangular" height={80} animation="wave" sx={{ borderRadius: 8 }} />

      {/* Subscribe button area */}
      <div className="mt-4">
        <Skeleton variant="rectangular" height={44} animation="wave" sx={{ borderRadius: 8 }} />
      </div>
    </div>
  );
};

export const ProductDetailLeftSkeleton = () => {
  const loadingImages = [1, 2, 3, 4, 5];
  return (
    <div className="product_detail_left_section">
      <div className="product_detail_image_box">
        <Skeleton variant="rectangular" width="100%" height={400} animation="wave" />
        <div className="product_detail_image_gallery">
          {loadingImages.map((_, i) => (
            <Skeleton key={`loading-image-${i}`} variant="rectangular" width={80} height={80} animation="wave" />
          ))}
        </div>
      </div>
    </div>
  );
};

export const OrderSummarySkeleton = () => {
  return (
    <div className="order-summary-container">
      <div className="bg-white rounded-lg shadow-sm p-4 border border-gray-100">
        {/* Header */}
        <Skeleton variant="text" width={120} height={22} animation="wave" sx={{ mb: 8 / 2 }} />
        <Skeleton variant="rectangular" width="100%" height={1} animation="wave" sx={{ mb: 12 / 2 }} />

        {/* Mode row */}
        <div className="flex justify-between items-center mb-3">
          <Skeleton variant="text" width={60} height={18} animation="wave" />
          <Skeleton variant="text" width={90} height={18} animation="wave" />
        </div>

        {/* Center note */}
        <div className="flex justify-center mb-4">
          <Skeleton variant="text" width={150} height={16} animation="wave" />
        </div>

        {/* Buttons */}
        <div className="flex gap-2 mb-1">
          <Skeleton variant="rectangular" height={36} animation="wave" sx={{ flex: 1, borderRadius: 9999 }} />
          <Skeleton variant="rectangular" height={36} animation="wave" sx={{ flex: 1, borderRadius: 9999 }} />
        </div>
      </div>

      {/* Divider and subscribe button */}
      <div className="my-3 mx-[.25rem]">
        <Skeleton variant="rectangular" width="100%" height={1} animation="wave" />
      </div>
      <Skeleton variant="rectangular" height={44} animation="wave" sx={{ borderRadius: 9999 }} />
    </div>
  );
};
